export const BRAZIL = 1
export const PARAGUAY = 2
export const UNITED_STATES = 3
